import React from 'react'
import "./Incubation.css";
import { Backtotop, Floatinmenu, Underline } from '../../widgets';
import { FaComputer } from 'react-icons/fa6';
import { incubation_menu, Incubation_mous, incubation_img_corousal } from '../../constants/incubation';
import { RadialMenu, Table, Heroimagecarousal } from '../../components';
import { useEffect } from 'react';
const Incubation_mou = () => {
  useEffect(() => {
    document.title = 'ACCET-Incubation | MoUs';
  }, []);
  const columns = [
    { field: "s.no", header: "sno" },
    { field: "companyName", header: "COMPANY NAME " },
    { field: "FocusSector", header: "FOCUS SECTOR" },
    { field: "ServiceProvided", header: "SERVICE PROVIDED" },
  ];
  return (
    <div className="incubationdept">
      <Heroimagecarousal
        key={incubation_img_corousal.id}
        title={incubation_img_corousal.title}
        img_list={incubation_img_corousal.img_list}
      />
      <section className="incubationdark">
        <Underline heading="Industry Relation MoUs" />
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={incubation_menu} />
        </div>
        <RadialMenu menu_links={incubation_menu} />
        <div className='incubation_mou_table'>
          <Table data={Incubation_mous} columns={columns} />
        </div>
      </section>

      <Backtotop />
    </div>
  );
}

export default Incubation_mou;